module.exports = __webpack_public_path__ + "static/img/1-1.be0a782.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/1-1.png
// module id = OAAl
// module chunks = 0